import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomTextAreaWrapper, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithoutSource } from '../../componentTypes';

const TitleInput: InputWithoutSource = ({ input }) => {
    return (
        <CustomFormItem
            name={input.guid}
            required={input.required}
            message={ValidationMessages.requiredInput(input.name)}
            isReadOnly={input.isReadOnly}
        >
            <CustomTextAreaWrapper
                input={input}
                label={input.name}
                topRightNode={<InputControls input={input} />}
                maxLength={60}
            />
        </CustomFormItem>
    );
};

TitleInput.meta = {
    inputType: InputModel.name
};

export default observer(TitleInput);
